import { render, staticRenderFns } from "./FlipReveal.vue?vue&type=template&id=42a77e44&scoped=true&"
import script from "./FlipReveal.vue?vue&type=script&lang=ts&"
export * from "./FlipReveal.vue?vue&type=script&lang=ts&"
import style0 from "./FlipReveal.vue?vue&type=style&index=0&id=42a77e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a77e44",
  null
  
)

export default component.exports